module.exports = {
  siteTitle: 'Galang Martial Arts',
  siteDescription: 'Resources and Tools for the serious martial artist',
  siteUrl: 'https://www.galangmartialarts.com' // Site domain. Do not inculde a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
};



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js